export { ProductImage as default } from './product-image';
